export default {
  preferences: {
    title: "Preferenze",
    promo: {
      blurb: "Giocate avanzate.\nInsight più profondi.",
    },
    sections: {
      account: "Account",
      display: "Visualizzazione",
      support: "Supporto",
      about: "Informazioni",
    },
    items: {
      profile: "Profilo",
      location: "Posizione",
      manageSubscription: "Gestisci abbonamento",
      glossary: "Glossario",
      contactSupport: "Contatta supporto",
      logOut: "Esci",
      deleteAccount: "Elimina account",
    },
    profile: {
      title: "Profilo",
      alerts: {
        passwordMessage: "Per cambiare password, visita linemate.io",
        usernameInvalid: "Il nome utente deve avere almeno 6 caratteri. Deve contenere solo lettere e numeri.",
        usernameTaken: "Nome utente già in uso",
      },
      saved: "Profilo salvato",
    },
    display: {
      preferences: {
        theme: "Tema",
        odds: "Quote",
        language: "Lingua",
      },
      options: {
        theme: {
          "Match System": "Usa sistema",
          Light: "Chiaro",
          Dark: "Scuro",
        },
        odds: {
          american: "Americano",
          decimal: "Decimale",
        },
      },
    },
    language: {
      loading: "Aggiornamento lingua...",
    },
    about: {
      terms: "Termini",
      privacy: "Privacy",
      responsibleGambling: "Gioco responsabile",
      openSourceLibraries: "Librerie open source",
      acknowledgments: "Ringraziamenti",
    },
    subscription: {
      alertTitle: "Abbonamento",
      webMessage: "Per gestire l'abbonamento, visita la sezione profilo su linemate.io",
      googlePlayMessage: "Per gestire l'abbonamento, visita la sezione Abbonamenti del tuo account Google Play associato a questo acquisto",
      appleMessage: "Per gestire l'abbonamento, visita la sezione Abbonamenti del tuo account Apple associato a questo acquisto",
      manageTitle: "Gestisci abbonamento",
      currentPlan: "Piano attuale",
      changePlan: "Cambia piano",
      cancelPlan: "Annulla abbonamento",
      cancelTitle: "Annulla abbonamento",
      cancelHeading: "Perché stai annullando?",
      cancelSubtitle: "Il tuo feedback ci aiuterà a migliorare il prodotto.",
      missingTitle: "Cosa manca?",
      missingSubtitle: "Quali funzionalità o strumenti renderebbero Linemate più utile per te?",
      improveTitle: "Dicci come migliorare",
      improveSubtitle: "Il tuo feedback ci aiuta a migliorare.",
      trialActive: "La tua prova Linemate+ è ancora attiva.",
      alreadyActive: "Hai già accesso a Linemate+",
      exclusiveOfferFallbackTitle: "Offerta esclusiva",
      exclusiveOfferFallbackSubtitle: "Mantieni l'accesso con un'offerta a tempo limitato prima di annullare.",
      claimOneTimeOffer: "Riscatta offerta unica",
      offerApplyFailure: "Non siamo riusciti ad applicare questa offerta ora. Riprova più tardi.",
      continueToCancel: "Continua per annullare",
      losingAccessTitle: "Perderai l'accesso alle nostre ultime funzionalità avanzate",
      losingAccessSubtitle: "Ecco cosa perderai quando il piano finirà.",
      keepSubscription: "Mantieni abbonamento",
      feedbackPlaceholder: "Inserisci la tua risposta...",
    },
    providers: {
      locationTitle: "Consenti a Linemate di accedere alla tua posizione per impostare le quote preferite",
      locationSubtitle: "Linemate usa la tua posizione per mostrare provider nella tua zona",
    },
    location: {
      title: "Posizione",
      useCurrentLocation: "Usa posizione attuale",
      enableLocationMessage: "Risparmia tempo e consenti la condivisione della posizione per mostrarti i migliori mercati e offerte.",
    },
    logout: {
      title: "Esci",
      message: "Sei sicuro di voler uscire?",
    },
    deleteAccount: {
      warningTitle: "Avviso",
      warningMessage: "Hai un abbonamento attivo; dovrai annullarlo prima di eliminare l'account.",
      confirmTitle: "Elimina account",
      confirmMessage: "Sei sicuro di voler eliminare il tuo account?",
      confirmAction: "Elimina",
      successTitle: "Elimina account",
      successMessage: "Il tuo account è stato eliminato con successo.",
      errorTitle: "Errore",
    },
    communication: {
      title: "Comunicazione",
      email: "Email",
      emailDescription: "Email di marketing, aggiornamenti di ricerca, novità prodotto e annunci occasionali della piattaforma.",
      notificationSettings: "Impostazioni notifiche",
      notificationDescription: "Notifiche marketing, promemoria prima delle finestre importanti delle partite e aggiornamenti su nuove funzionalità.",
    },
    feedback: {
      title: "Invia feedback",
      enjoymentPrompt: "Ti sta piacendo l'esperienza?",
      improvePrompt: "Dicci come possiamo migliorare. Ogni feedback aiuta.",
      actions: {
        yes: "Sì",
        no: "No",
        contactUs: "Contattaci",
        notNow: "Non ora",
      },
      communication: {
        title: "Comunicazione",
        email: "Email",
        emailDescription: "Email di marketing, aggiornamenti di ricerca, novità prodotto e annunci occasionali della piattaforma.",
        notificationSettings: "Impostazioni notifiche",
        notificationDescription: "Notifiche marketing, promemoria prima delle finestre importanti delle partite e aggiornamenti su nuove funzionalità.",
      },
    },
  },
};
